import React from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../redux/actions/auth.actions";
import { REACT_APP_MODE } from "../config";
import { Translation } from "react-i18next";

function Nav(props) {
  const dispatch = useDispatch();
  const handleLogout = () => dispatch(logout());

  let applicationVersion;
  try {
    applicationVersion = require("../../package.json").version;
  } catch (err) {
    applicationVersion = "N/A";
  }

  const selected = props.selected;
  return (
    <Translation>
      {t => (
        <div id="nav">
          <div id="nav-logo"></div>
          <ul id="menu">
            <li>
              <Link
                to="/campaigns"
                className={`nav-button ${
                  selected === "campaigns" ? "selected" : ""
                }`}
              >
                <i className="fal fa-calendar-star"></i>
                <span>{t("common.campaigns")}</span>
              </Link>
            </li>
            <li>
              <Link
                to="/sites"
                className={`nav-button ${
                  selected === "sites" ? "selected" : ""
                }`}
              >
                <i className="fal fa-location-circle"></i>
                <span>{t("common.sites")}</span>
              </Link>
            </li>
            <li>
              <Link
                to="/assets"
                className={`nav-button ${
                  selected === "assets" ? "selected" : ""
                }`}
              >
                <i className="fal fa-user-shield"></i>
                <span>{t("common.assets")}</span>
              </Link>
            </li>
            <li>
              <Link
                to="/events"
                className={`nav-button ${
                  selected === "events" ? "selected" : ""
                }`}
              >
                <i className="fal fa-list-alt"></i>
                <span>{t("common.events")}</span>
              </Link>
            </li>
            <li>
              <Link
                to="/help"
                className={`nav-button ${
                  selected === "help" ? "selected" : ""
                }`}
              >
                <i className="fal fa-question"></i>
                <span>{t("common.help")}</span>
              </Link>
            </li>
          </ul>
          <div id="nav-last">
            <div id="nav-version">
              {t("system.version")}: {applicationVersion}
            </div>
            <a href="/" onClick={() => handleLogout()}>
              <i className="fal fa-sign-out"></i>
              {t("auth.logout_button")}
            </a>
          </div>
        </div>
      )}
    </Translation>
  );
}
export default Nav;
